import line from "./line"
import fetchGradients from "~/components/circuit/fetchGradients"
import Tiles from "~/components/tiles"
import { Spinner } from "evergreen-ui"
import { max, flatten } from "lodash"
import { scaleLinear } from "d3-scale"

export default class Weights2 extends Component {
  state = { weights: null }

  componentWillMount() {
    fetchGradients("inceptionv1", "mixed3a", "mixed3b").then(weights => {
      this.setState({ weights })
    })
  }

  render() {
    const { weights } = this.state

    if (!weights) {
      return <Spinner />
    }

    const ZoomedImg = ({ src, size, padding, style, ...props }) => (
      <div
        style={Object.assign({}, style, {
          width: size,
          height: size,
          overflow: "hidden",
          borderRadius: 5,
          position: "relative",
        })}
        {...props}
      >
        <img
          src={src}
          width={size + padding * 2}
          height={size + padding * 2}
          style={{ position: "absolute", left: -padding, top: -padding }}
        />
      </div>
    )

    const size = 90
    const top = 35
    const row = (upstreamNeuron, neuron) => (
      <Surface position="relative">
        <Surface position="absolute" left={50} top={top}>
          <ZoomedImg
            size={size}
            padding={40}
            src={neuronFeatureVis("inceptionv1", "mixed3a", upstreamNeuron)}
          />
        </Surface>
        {line}
        <Surface
          position="absolute"
          left={200}
          top={top}
          borderRadius={5}
          style={{ border: "1px solid rgba(0, 0, 0, 0.2)" }}
          overflow="hidden"
        >
          <Tiles
            size={size}
            hasBorder={false}
            scale={scaleLinear().domain([
              0,
              35,
              // max(flatten(weights[upstreamNeuron][neuron])),
            ])}
            grad={weights[upstreamNeuron][neuron]}
          />
        </Surface>

        <Surface position="absolute" right={40} top={top}>
          <img
            src={neuronFeatureVis("inceptionv1", "mixed3b", neuron)}
            style={{ borderRadius: 5 }}
            width={90}
            height={90}
          />
        </Surface>
      </Surface>
    )

    const Annotate = ({ children, x, y, size = 40 }) => (
      <Surface position="relative">
        <Surface
          width={size}
          borderRadius={size}
          height={size}
          left={x}
          top={y}
          zIndex={1000}
          position="absolute"
          style={{ border: "2px solid rgba(0, 0, 0, 0.6)" }}
        />
        {children}
      </Surface>
    )

    return (
      <Surface alignItems="center" marginY={40}>
        <Surface flexFlow="row">
          <Surface>
            <Text alignSelf="center" textAlign="center" size={600} width={370}>
              Curve detectors are excited by earlier detectors in{" "}
              <b>similar orientations</b>
            </Text>
            {row(147, 379)}
            {row(81, 385)}
            {row(71, 340)}
            {row(145, 388)}
          </Surface>
          <Surface>
            <Text alignSelf="center" textAlign="center" size={600} width={330}>
              They are inhibited by earlier detectors in{" "}
              <b>opposing orientations</b>
            </Text>
            {row(145, 379)}

            {row(71, 385)}
            {row(81, 340)}
            {row(147, 388)}
          </Surface>
        </Surface>
        <Surface alignItems="center" marginTop={30}>
          <Text textAlign="center" size={600} width={480}>
            Interestingly, curves use <b>negative weights</b> to inhibit earlier
            curves that are close but not quite right.
          </Text>
          <Surface flexFlow="row">
            <Annotate x={190} y={42}>
              {row(147, 379)}
            </Annotate>
            <Annotate x={244} y={41}>
              {row(71, 340)}
            </Annotate>
          </Surface>
        </Surface>
      </Surface>
    )
  }
}
